import { ChartContext } from '../interface';
import { convertDateStringToUTC } from './helper';

export const createDrawdownSeries = (
  quotes: ChartContext.IAssetQuotes[] | undefined
): Highcharts.SeriesOptionsType[] => {
  if (!quotes) return [];

  const series = quotes.map((asset) => {
    let peak = 0;

    return {
      lineWidth: 0.7,
      fillOpacity: 0.2,
      type: 'area' as any,
      id: asset.id,
      data: asset.quotes.map(({ d, c, q }) => {
        const quote = (c || q) as number;
        const period = convertDateStringToUTC(d);

        if (peak === 0) {
          peak = quote;
        }

        const under = (quote / peak - 1) * 100;

        if (quote > peak) {
          peak = quote;
        }

        return under < 0 ? [period, under] : [period, 0.0];
      }),
      name: asset.shortname || asset.name || asset.nicename,
      color: asset.color,
    };
  });

  return series;
};
